import { defineComponent, renderSlot } from 'vue'
import type { ExtractPropTypes } from 'vue'

import { provideThroneContext } from '../../Throne/hooks/use-throne-context'

import { withInstall } from '../_util'

export const throneContextProviderProps = () => ({
  context: Object,
})

export type ThroneContextProviderProps = Partial<ExtractPropTypes<ReturnType<typeof throneContextProviderProps>>>

export type ThroneContextProviderContext = Partial<ThroneContextProviderProps>

const ThroneContextProvider = defineComponent({
  name: 'OThroneContextProvider',
  inheritAttrs: false,
  props: throneContextProviderProps(),
  setup(props, { slots }) {
    provideThroneContext(props)
    return () => {
      return renderSlot(slots, 'default')
    }
  },
})

export default withInstall<typeof ThroneContextProvider, {}>(ThroneContextProvider)
